import { useQuery } from '@tanstack/react-query';
import { companyRelationshipApi } from 'shared/services/companyRelationshipApi';
import { queryKeys } from '../queryConfig';

/**
 * Whether the CURRENT session's active company should be entirely blocked
 * — the caller has their own (non-external) membership in it, it's a
 * provider company, and it has no active plan. Login and switch-company
 * deliberately don't filter this out (a planless provider can still switch
 * into a client company they're assigned to, since that entry is
 * isExternal:true and this check only ever fires for the non-external one)
 * — Layout.tsx checks this on every mount to decide whether to render
 * ProviderPlanBlockedScreen instead of the sidebar + normal routes.
 */
export function useProviderPlanBlock() {
  const query = useQuery({
    queryKey: queryKeys.companyRelationships.myProviderPlanBlock(),
    queryFn: () => companyRelationshipApi.getMyProviderPlanBlock(),
    staleTime: 30 * 1000,
  });

  return {
    blocked: query.data?.blocked === true,
    companyName: query.data?.companyName,
    // Treat the unresolved state as "not yet known" rather than blocked —
    // Layout.tsx should keep the normal shell (or a brief loader) up rather
    // than flash the blocked screen before the check resolves.
    loading: query.isLoading,
  };
}
